// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ytRu","content":"LayoutSettings_content__20GCc"};